<template>
<div class="chapter">
<div class="inner_page">
<h2 class="tocf"><a href="#/xhtml/04_Preface">Preface and Acknowledgments</a></h2>
<h2 class="tocf"><a href="#/xhtml/05_Introduction">Introduction</a></h2>
<h3 class="tocf1"><a href="#/xhtml/05_Introduction#id1"><span class="bold"><span class="tocpada">I.</span> The Contents of the Dictionary</span></a></h3>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id2">Preliminary</a></h4>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id3">The Historical Background</a></h4>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id4">The Anglicization of Foreign Words</a></h4>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id5">The Meaning of ‘Foreign’</a></h4>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id6">Some Positive Criteria</a></h4>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id7">Some Negative Criteria</a></h4>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id8">Practical Conclusions</a></h4>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id9">‘Current’ Words</a></h4>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id10">‘Current’ Phrases</a></h4>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id11">The Classification of ‘Foreign’ Expressions</a></h4>
<h4 class="toc2"><a href="#/xhtml/05_Introduction#id12">Why Some Expressions Remain ‘Foreign’</a></h4>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id13">The Dating of ‘Foreign’ Expressions</a></h4>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id14">Some Tables of Statistics</a></h4>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id15">The Historical Significance of ‘Foreign’ Expressions</a></h4>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id16">The Origins of Quotations</a></h4>
<h3 class="tocf1"><a href="#/xhtml/06_Introduction_1#id17"><span class="bold"><span class="tocpadb">II.</span> The Use and Abuse of ‘Foreign’ Words and Phrases</span></a></h3>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id18">‘Description’ and ‘prescription’</a></h4>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id19">The Use of ‘Foreign’ Expressions</a></h4>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id20">The Pronunciation and Spelling of ‘Foreign’ Expressions</a></h4>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id21">The Pronunciation and Spelling of Latin</a></h4>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id22">The Spelling of Greek</a></h4>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id23">The Pronunciation of Greek</a></h4>
<h4 class="toc2"><a href="#/xhtml/06_Introduction_1#id24">Languages Written in Non-Roman Scripts</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id25">The Spelling of European Languages</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id26">The Pronunciation of European Languages</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id27">The Use of Foreign Feminine Forms in English</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id28">The Use of Foreign Plurals in English</a></h4>
<h3 class="tocf1"><a id="page_x"></a><a href="#/xhtml/07_Introduction_2#id29"><span class="bold"><span class="tocpad">III.</span> The Arrangement of the Dictionary</span></a></h3>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id30">The Alphabetic Arrangement</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id31">The Head-Word</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id32">The Etymology</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id33">Specialized and Technical Usage</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id34">The Definition</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id35">The Date of Introduction</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id36">Notes on Points of Interest</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id37">Cross-References</a></h4>
<h4 class="toc2"><a href="#/xhtml/07_Introduction_2#id38">Illustrative Quotations</a></h4>
<h2 class="tocf"><span href="#/xhtml/08_Abbreviations" title="Link target outside of Sample">List of Abbreviations</span></h2>
<h2 class="tocf"><span href="#/xhtml/09_Chapter1" title="Link target outside of Sample"><span class="bold">A Dictionary of Foreign Words and Phrases</span></span></h2>
<h2 class="tocf">Appendix: Language of Origin and Date of Introduction</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?005fca30